import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/rbac`;

export const rbacApi = {
  myPermissions: () => axios.get(`${BASE}/my-permissions`),
  rights: () => axios.get(`${BASE}/meta/rights`),
  doctypes: () => axios.get(`${BASE}/meta/doctypes`),
  doctypeCatalog: () => axios.get(`${BASE}/meta/doctype-catalog`),
  applyStarterProfile: (overwrite = false) => axios.post(`${BASE}/permissions/apply-starter-profile?overwrite=${overwrite}`),

  listRoles: () => axios.get(`${BASE}/roles`),
  createRole: (p) => axios.post(`${BASE}/roles`, p),
  updateRole: (id, p) => axios.put(`${BASE}/roles/${id}`, p),
  deleteRole: (id) => axios.delete(`${BASE}/roles/${id}`),

  listProfiles: () => axios.get(`${BASE}/role-profiles`),
  createProfile: (p) => axios.post(`${BASE}/role-profiles`, p),
  updateProfile: (id, p) => axios.put(`${BASE}/role-profiles/${id}`, p),
  deleteProfile: (id) => axios.delete(`${BASE}/role-profiles/${id}`),

  listUsers: () => axios.get(`${BASE}/users`),
  createUser: (p) => axios.post(`${BASE}/users`, p),
  updateUser: (id, p) => axios.put(`${BASE}/users/${id}`, p),
  deleteUser: (id) => axios.delete(`${BASE}/users/${id}`),

  listPermissions: (params = {}) => axios.get(`${BASE}/permissions`, { params }),
  upsertPermission: (p) => axios.post(`${BASE}/permissions`, p),
  deletePermission: (id) => axios.delete(`${BASE}/permissions/${id}`),

  listUserPermissions: (params = {}) => axios.get(`${BASE}/user-permissions`, { params }),
  createUserPermission: (p) => axios.post(`${BASE}/user-permissions`, p),
  deleteUserPermission: (id) => axios.delete(`${BASE}/user-permissions/${id}`),
};

export default rbacApi;
